/**
 * File: /home/cordova03/projects/educore_3.5/src/app/utilities/controllers/curriculumSetupController.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Wednesday, December 5th 2018, 3:00:18 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 19 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

class CurriculumSetupController {
    constructor($scope, $rootScope, authService, localStorageService, $state, $mdDialog) {
        'ngInject';
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Curriculum Setup"

            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        let self = this

        self.reset = () => {
            self.isEdit = false;
            self.errors = {};
            self.curriculumAvailablility = null;
            self.curriculum = {}
        }

        $scope.getList = function (schoolId) {
            self.reset()
            authService.callAPI("/v0/school/details/" + schoolId + "/curriculum", "GET", null, function (response) {
                try {
                    $scope.curriculums = response.result.data.data
                } catch (e) {
                    $scope.curriculums = []
                }
                $scope.$apply()
            })
        }

        let schoolId = localStorageService.get('school_id')
        $scope.getList(schoolId)

        this.saveCurriculum = () => {
            $scope.loading = true
            let toSave = {
                school_id: schoolId,
                curriculum_name: this.curriculum.name
            }

            var method = "POST"
            var message = "Curriculum created successfully"
            if (this.isEdit) {
                method = "PUT"
                toSave.curriculum_id = self.curriculum._id
                message = "Curriculum updated successfully"
            }

            authService.callAPI("/v0/utilities/curriculum/setup", method, toSave, function (response) {
                if (response && response.result) {
                    toastr.success(message);
                    $scope.loading = false
                    $scope.getList(schoolId)
                } else {
                    try {
                        console.log(response.error);

                        self.errors = {}

                        if (response.error.status.code == 400) {
                            toastr.error(response.error.error.message)
                        }

                        if (response.error.status.code == 422) {

                            let error = response.error.error.errors
                            if (error.curriculum_name && error.curriculum_name['param'] == 'curriculum_name') {
                                self.errors.name = error.curriculum_name['msg']
                            }
                        }
                    } catch (ex) {
                        console.log(ex);
                    }
                }
            })
        }

        self.removeCurriculum = (curId, currName) => {
            var requestBody = {
                school_id: schoolId,
                curriculum_id: curId
            }
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete ' + currName + "?")
                .textContent('')
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function () {
                $scope.loading = true
                authService.callAPI("/v0/utilities/curriculum/setup", "DELETE", requestBody, function (response) {
                    if (response && response.result) {
                        self.reset()
                        $scope.getList(schoolId)
                        $scope.loading = false
                        toastr.success('Successfully removed!');
                    } else {
                        let error = response.error
                        try {
                            toastr.error(error.error.message);
                            $scope.loading = false
                        } catch (ex) {
                            toastr.error(error);
                        }
                    }
                })
            });
        }

        this.editCurriculum = function (curriculum) {
            this.isEdit = true;
            this.focusMe = true;
            this.oldCurriculum = curriculum.name
            this.curriculum = angular.copy(curriculum);
        }

        this.openMenu = function ($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        };

        this.$onDestroy = () => {

        }
    }
}

export default CurriculumSetupController;



// WEBPACK FOOTER //
// ./src/app/utilities/curriculumSetup/controllers/curriculumSetupController.js